import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutDataDecentral() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Data Decentralization</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>One of our goals is to demonstrate how applications can be built in a decentralized manner.</p>;
    t2 = <p>Effectively all information on 6529.io comes from on-chain or public sources or is derived in transparent ways from on-chain or public sources. This means anyone can replicate the data available on this site for a website or application of their own, without seeking permission from us and without any dependency on us.</p>;
    t3 = <p>This page shares the source of all data displayed on 6529.io.</p>;
    t4 = <p>On-Chain (Ethereum)</p>;
    t5 = <ul><li>The token #</li><li>The location (URI/URL) of the JSON with the token's metadata</li><li>The collectors' Ethereum addresses</li><li>The collectors' NFTs currently owned, as well as bought, sold or transfered</li><li>ENS addresses of collectors</li></ul>;
    t6 = <p>Arweave (Decentralized storage)</p>;
    t7 = <ul><li>The image of the art associated with each NFT</li><li>The metadata for the NFT</li></ul>;
    t8 = <p>OpenSea API</p>;
    t9 = <ul><li>NFT listing prices on OpenSea</li></ul>;
    t10 = <p>Internal Database</p>;
    $[1] = t1;
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t1 = $[1];
    t10 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ul><li>6529 Team addresses. A record of these can be found on Arweave{" "}<Link href="https://arweave.net/fy83ffOGqR9cR2zooI7u9JxsG0oEWVJxH3B-bNxXKJg" target="_blank" rel="noopener noreferrer">here</Link>. We will move this list 100% on-chain in the coming weeks.</li></ul>;
    t12 = <p>Internally Calculated / Computed</p>;
    t13 = <ul><li>Thumbnail images to match the site design (transformed from the original image from Arweave)</li><li>TDH values (calculated from on-chain data, using this formula. We will release sample code for this calculation soon)</li></ul>;
    t14 = <p>Compiled 6529.io Data</p>;
    t15 = <li>Even though everyone can compile and calculate the same data as us, we also export daily all our compiled and calculated data for the convenience of those without programming backgrounds</li>;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Container>{t0}<Row className="pt-3 pb-3"><Col className="text-left">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}<ul>{t15}<li>Every day, we post our complete set of on-chain and calculated values shown on the site to Arweave as a CSV. The specific links can be found{" "}<Link href="/open-data" target="_blank" rel="noopener noreferrer">here</Link>.</li></ul></Col></Row></Container>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
}